import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import {  ROUTE_PATHS } from 'src/app/route-paths';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'route',
  pure: false // Pure olarak ayarlıyoruz, çünkü dil değiştiğinde güncellenmesi gerekiyor
})
export class RoutePipe implements PipeTransform {
  private currentLanguage: string;
  private subscription: Subscription;

  constructor(private languageService: LanguageService, private cdr: ChangeDetectorRef) {
    this.subscription = this.languageService.currentLanguage$.subscribe(language => {
      this.currentLanguage = language;
      this.cdr.markForCheck(); // Değişiklikleri işaretle
    });

    //this.currentLanguage = this.languageService.getDefaultLanguage(); // Başlangıç dilini al
  }

  transform(route: string): string {
    if(this.currentLanguage && this.currentLanguage!=''){
      // Türkçe default dil, önek ekleme
      if(this.currentLanguage === 'tr'){
        if(route=='home'){
          return '/';
        }
        else{
          return '/' + ROUTE_PATHS[this.currentLanguage][route];
        }
      }
      // İngilizce için /en öneki ekle
      else {
        if(route=='home'){
          return `/${this.currentLanguage}`;
        }
        else{
          return `/${this.currentLanguage}/` + ROUTE_PATHS[this.currentLanguage][route];
        }
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe(); // Subscription'ı temizle
  }
}
